export default __webpack_public_path__ + "static/media/black-check-icon.84fc5464.svg";